import React, {h, Component} from 'preact';
import {PropTypes} from 'preact-compat';
import RatingComponent from './RatingComponent';
import RatingComponent5 from './RatingComponent5';
import EndorsementComponent from './EndorsementComponent';
import './ClientNPSSurvey.scss';

class ClientNPSSurvey extends Component {
    static get propTypes() {
        return {
            feedbackType: PropTypes.oneOf(['BUYER_FEEDBACK', 'NPS_SURVEY']),
            realtorName: PropTypes.string,
            realtorId: PropTypes.number,
            availableEndorsements: PropTypes.array,
            email: PropTypes.string,
            requestId: PropTypes.number,
            adminId: PropTypes.number,
            buy: PropTypes.bool,
            surveyType: PropTypes.string,
            thankYou: PropTypes.bool,
            // hasUHL: PropTypes.bool, TODO:: Remove UHL
            buyerName: PropTypes.string,
            buyerEmail: PropTypes.string,
            buyerPhone: PropTypes.string,
            buyerState: PropTypes.string,
            buyerCity: PropTypes.string,
            buyerZip: PropTypes.string,
            showNPS: PropTypes.bool,
            nps: PropTypes.number
        };
    }

    constructor(props) {
        super(props);
        this.state = {
            email: props.email,
            isFinished: props.thankYou,
            nps: props.nps ? props.nps: 10,
            upnestImprove: null,
            agentImprove: null,
            endorsementIds: null,
            satisfaction: 5,
            satisfactionError: false,
            npsError: false,
            upnestImproveError: false,
            upnestImproveErrorMax: false,
            emailError: null,
            agentImproveError: false
        };
    }

    submit() {
        this.setState({
            satisfactionError: false,
            npsError: false,
            upnestImproveError: false,
            upnestImproveErrorMax: false,
            emailError: null,
            agentImproveError: false
        });

        let scroller = false;

        if (this.props.feedbackType === 'BUYER_FEEDBACK') {
            if (!this.state.email) {
                this.setState({emailError: 'blank'});
            } else {
                if (!isValidEmailAddress(this.state.email)) {
                    this.setState({emailError: 'invalid'});
                    if (scroller == false) {
                        $('.email-input')[0].scrollIntoView({behavior: 'smooth', block: 'center', inline: 'center'});
                        scroller = true;
                    }
                }
            }
            if (!this.state.nps) {
                this.setState({npsError: true});
            }
            if (!this.state.upnestImprove) {
                this.setState({upnestImproveError: true});
                if (scroller == false) {
                    $('.improve-input')[0].scrollIntoView({behavior: 'smooth', block: 'center', inline: 'center'});
                    scroller = true;
                }
            }
        }
        if (!this.state.satisfaction) {
            this.setState({satisfactionError: true});
            if (scroller == false) {
                $('.scores')[0].scrollIntoView({behavior: 'smooth', block: 'center', inline: 'center'});
                scroller = true;
            }
        }
        if (
            this.state.satisfactionError ||
            this.state.npsError ||
            this.state.upnestImproveError ||
            this.state.upnestImproveErrorMax ||
            this.state.emailError ||
            this.state.agentImproveError
        ) {
            return;
        }

        this.setState({isLoading: true});

        const params = [
            {name: 'realtorId', value: this.props.realtorId},
            {name: 'requestId', value: this.props.requestId},
            {name: 'buy', value: this.props.buy},
            {name: 'assignedAdmin.userId', value: this.props.adminId},
            {name: 'surveyType', value: this.props.surveyType},
            {name: 'upnestImprove', value: this.state.upnestImprove},
            {name: 'agentSatisfaction', value: this.state.satisfaction},
            {name: 'agentImprove', value: this.state.agentImprove}
        ];
        if (this.props.feedbackType === 'BUYER_FEEDBACK') {
            trackEvent('Survey', 'npsBuyer', 'buyerSubmitSurvey').withGA();
            params.push({name: 'NPS', value: this.state.nps});
            params.push({name: 'email', value: this.state.email});
            params.push({name: 'endorsementIds', value: this.state.endorsementIds});
        } else if (this.props.showNPS) {
            params.push({name: 'NPS', value: this.state.nps});
        }

        $.post('submit-feedback-json', params)
            .then(data => {
                if (checkAjax(data)) {
                    this.setState({isFinished: true});
                }
            })
            .fail(defaultAjaxError)
            .always(() => {
                this.setState({isLoading: false});
            });
    }

    // TODO:: Remove UHL
    // trackInterestedInHomeLoan = () => {
    //     const {requestId} = this.props;
    //     $.post('processBuyerHomeLoanAnswer-json', {
    //         requestId: requestId,
    //         answer: 'yes',
    //         source: 'Buyer Dashboard - Survey thank you page'
    //     });
    // };

    onAgentImproveKeyDown(value) {
        if (value.length > 1495) {
            this.setState({agentImproveError: true});
        } else {
            this.setState({agentImproveError: false});
        }
        //const keyCode = event.keyCode || event.which;
        //if (keyCode == 32) {
        //    event.preventDefault();
        //}
    }

    onUpnestImproveKeyDown(value) {
        if (value.length > 1495) {
            this.setState({upnestImproveErrorMax: true});
        } else {
            this.setState({upnestImproveErrorMax: false});
        }
    }

    render() {
        const {
            feedbackType,
            realtorName,
            realtorId,
            availableEndorsements,
            showNPS,
            // hasUHL, TODO:: Remove UHL
            buyerName,
            buyerEmail,
            buyerPhone,
            buyerState,
            buyerCity,
            buyerZip
        } = this.props;
        const {
            maxParts,
            isFinished,
            isLoading,
            upnestImprove,
            agentImprove,
            nps,
            satisfaction,
            email,
            satisfactionError,
            npsError,
            upnestImproveError,
            upnestImproveErrorMax,
            emailError,
            agentImproveError
        } = this.state;

        // TODO:: Remove UHL
        // const homeLoansBannerLink =
        //     'https://upnesthomeloans.com/consultation?name=' +
        //     encodeURIComponent(buyerName) +
        //     '&email=' +
        //     encodeURIComponent(buyerEmail) +
        //     '&phone=' +
        //     encodeURIComponent(buyerPhone) +
        //     '&state=' +
        //     encodeURIComponent(buyerState) +
        //     '&city=' +
        //     encodeURIComponent(buyerCity) +
        //     '&zip=' +
        //     encodeURIComponent(buyerZip) +
        //     '&utm_source=upnest&utm_medium=upnest_website&utm_campaign=survey_thank_you_page';

        this.partCounter = 0;

        const html = (
            <div className="survey">
                <div className="survey-header">
                    {feedbackType === 'NPS_SURVEY' && (
                        <div className="container">
                            <h1 className="survey-title">Let us know what you think</h1>
                            <h4 className="survey-subtitle">
                                We appreciate your honest feedback. Please fill out a quick survey and we will.
                            </h4>
                        </div>
                    )}
                    {feedbackType === 'BUYER_FEEDBACK' && (
                        <div className="container">
                            <h1 className="survey-title">Let us know what you think</h1>
                            <h4 className="survey-subtitle">
                                Congrats on buying your home with an UpNest partner agent. We woulds greatly appreciate
                                your feedback on the agent and our service.
                            </h4>
                        </div>
                    )}
                </div>
                <div className="container">
                    <div className="row">
                        <div className="col-xs-12">
                            {isFinished ? (
                                [
                                    <div className="survey-form thank-you">
                                        <svg
                                            width="54"
                                            height="54"
                                            viewBox="0 0 54 54"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                fillRule="evenodd"
                                                clipRule="evenodd"
                                                d="M0.599976 26.9999C0.599976 12.2999 12.6 0.599854 27 0.599854C41.7 0.599854 53.4 12.5999 53.4 26.9999C53.4 41.3999 41.4 53.3998 27 53.3998C12.3 53.3998 0.599976 41.6999 0.599976 26.9999ZM5.39998 26.9999C5.39998 38.9999 15 48.8998 27 48.8998C38.7 48.8998 48.6 38.9999 48.6 26.9999C48.6 14.9999 39 5.09985 27 5.09985C15 5.09985 5.39998 14.9999 5.39998 26.9999ZM15.6115 28.5187C16.4268 27.5873 17.7457 27.5873 18.561 28.5187L22.6949 33.2406L35.439 18.6985C36.2543 17.7672 37.5731 17.7672 38.3885 18.6985C39.2038 19.6298 39.2038 21.1362 38.3885 22.0675L24.1761 38.3015C23.3608 39.2328 22.0419 39.2328 21.2266 38.3015L15.6115 31.8877C14.7961 30.9564 14.7961 29.45 15.6115 28.5187Z"
                                                fill="#3889EB"
                                            />
                                        </svg>
                                        {feedbackType === 'NPS_SURVEY' && (
                                            <div className="thank-you-content">
                                                <div className="thank-you-1">Thank you for your feedback!</div>
                                                <div className="thank-you-2">Your survey was submitted.</div>
                                            </div>
                                        )}
                                        {feedbackType === 'BUYER_FEEDBACK' && (
                                            <div className="thank-you-content">
                                                <div className="thank-you-1">Thank you for your feedback!</div>
                                                <div className="thank-you-2">
                                                    If you are happy with our platform and service, we
                                                    would greatly appreciate you giving us a review on Facebook, Google
                                                    Plus or Best Business Bureau!
                                                </div>
                                                <div className="thank-you-apps">
                                                    <a href="https://www.facebook.com/upnest/reviews">
                                                        <div className="review-button facebook">
                                                            <i className="fa fa-facebook pull-left" />
                                                            <div className="text-left d-inline-block">
                                                                <div className="review-us">Review Us On</div>
                                                                <div className="review-media">Facebook</div>
                                                            </div>
                                                        </div>
                                                    </a>
                                                    <a href="https://www.google.com/search?q=UpNest&ludocid=11457588646313120222#lrd=0x0:0x9f01882b3e0ad1de,1">
                                                        <div className="review-button google">
                                                            <i className="fa fa-google-plus pull-left" />
                                                            <div className="text-left d-inline-block">
                                                                <div className="review-us">Review Us On</div>
                                                                <div className="review-media">Google +</div>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                    // TODO:: Remove UHL
                                    // feedbackType === 'BUYER_FEEDBACK' && hasUHL && (
                                    //     <div className="homeloans">
                                    //         <div className="row">
                                    //             <div className="col-xs-12 content">
                                    //                 <h3 className="card-title">
                                    //                     Get Pre-Approved for UpNest Home Loan’s special rate
                                    //                 </h3>
                                    //                 <div className="message">
                                    //                     Mortgage rates are on the rise. Lock in UpNest Home Loan’s
                                    //                     competitive rate, get pre-approved in minutes
                                    //                 </div>
                                    //                 <div>
                                    //                     <a
                                    //                         onClick={this.trackInterestedInHomeLoan}
                                    //                         className="btn button-custom orange rounded"
                                    //                         href={homeLoansBannerLink}
                                    //                         target="_blank">
                                    //                         Get a free consultation{' '}
                                    //                         <i className="icon icon-arrow-direct-right" />
                                    //                     </a>
                                    //                 </div>
                                    //             </div>
                                    //         </div>
                                    //     </div>
                                    // )
                                ]
                            ) : (
                                <div className="survey-form">
                                    {feedbackType === 'NPS_SURVEY' && (
                                        <div>
                                            {showNPS && (
                                                <div>
                                                    {void(this.partCounter++)}
                                                    <div className="visible-xs part-num">Part {this.partCounter} of {maxParts}</div>
                                                    <div className="question">
                                                        {this.props.nps ? (
                                                            <span className="part-q">Please confirm your recommendation score selection</span>
                                                        ) : (
                                                            <span className="part-q">How likely would you recommend UpNest to a friend?</span>
                                                        )}
                                                        <span className="required"> *Required</span>
                                                        <div className="hidden-xs part-num">Part {this.partCounter} of {maxParts}</div>
                                                    </div>
                                                    <RatingComponent
                                                        activeRange={nps}
                                                        minLabel={'Not all likely'}
                                                        maxLabel={'Extreme likely'}
                                                        onChange={newNPS => this.setState({nps: newNPS})}
                                                    />
                                                    {npsError && (<p className="error">This is a required field.</p>)}
                                                </div>
                                            )}
                                            <div>
                                                {void this.partCounter++}
                                                <div className="visible-xs part-num">
                                                    Part {this.partCounter} of {maxParts}
                                                </div>
                                                <div className="question">
                                                    <span className="part-q">
                                                        Do you like the website? What should we add? How was your
                                                        experience with our UpNest Advisor? Do you have any questions?
                                                    </span>
                                                    <div className="hidden-xs part-num">
                                                        Part {this.partCounter} of {maxParts}
                                                    </div>
                                                </div>
                                                <div className="answers columned">
                                                    <div className="answer-item fill-width">
                                                        <textarea
                                                            name="upnestImprove"
                                                            className="answer-input improve-input"
                                                            value={
                                                                typeof upnestImprove == 'string' ? upnestImprove : ''
                                                            }
                                                            placeholder="Type here..."
                                                            maxLength="1500"
                                                            onKeyDown={event =>
                                                                this.onUpnestImproveKeyDown(event.target.value)
                                                            }
                                                            onInput={e =>
                                                                this.setState({upnestImprove: e.target.value})
                                                            }
                                                            data-gramm="false"
                                                            data-gramm_editor="false"
                                                            data-enable-grammarly="false"
                                                        />
                                                    </div>
                                                </div>
                                                {upnestImproveErrorMax && <p className="error">Max Characters 1500</p>}
                                            </div>
                                            <div>
                                                {void(this.partCounter++)}
                                                <div className="visible-xs part-num">Part {this.partCounter} of {maxParts}</div>
                                                <div className="question">
                                                    <span className="part-q">
                                                        {realtorName
                                                            ?
                                                            <span>How satisfied are you with the overall experience with {realtorName}?</span>
                                                            :
                                                            <span>How satisfied are you with the overall experience with UpNest?</span>
                                                        }
                                                        <span className="required"> *Required</span></span>
                                                    <div className="hidden-xs part-num">Part {this.partCounter} of {maxParts}</div>
                                                </div>
                                                <div className="scores">
                                                    <ul className="score-circles">
                                                        <div className="hidden-xs unlikely">Not at all satisfied</div>
                                                        {[1, 2, 3, 4, 5].map(score => {
                                                            return <li key={score}
                                                                       className={this.state.satisfaction == score ? 'selected' : ''}
                                                                       onClick={() => this.setState({satisfaction: score})}>{score}</li>;
                                                        })}
                                                        <div className="hidden-xs likely">Extremely satisfied</div>
                                                    </ul>
                                                    <div className="visible-xs likelies">
                                                        <div className="unlikely">Not at all satisfied</div>
                                                        <div className="likely">Extremely satisfied</div>
                                                    </div>
                                                </div>
                                                {satisfactionError && (<p className="error">This is a required field.</p>)}
                                                <RatingComponent5
                                                    activeRange={satisfaction}
                                                    minLabel={'Not at all satisfied'}
                                                    maxLabel={'Extremely satisfied'}
                                                    onChange={newSatisfaction => this.setState({satisfaction: newSatisfaction})}
                                                />
                                                {satisfactionError && (<p className="error">This is a required field.</p>)}
                                            </div>
                                            <div>
                                                {void this.partCounter++}
                                                <div className="visible-xs part-num">
                                                    Part {this.partCounter} of {maxParts}
                                                </div>
                                                <div className="question">
                                                    <span className="part-q">
                                                        {realtorName ? (
                                                            <span>Any feedback for your agent {realtorName}?</span>
                                                        ) : (
                                                            <span>Any feedback for UpNest?</span>
                                                        )}
                                                    </span>
                                                    <div className="hidden-xs part-num">
                                                        Part {this.partCounter} of {maxParts}
                                                    </div>
                                                </div>
                                                <div className="nps-agent-improve answers columned">
                                                    <div className="answer-item fill-width">
                                                        <textarea
                                                            className="answer-input improve-input"
                                                            name="agentImprove"
                                                            value={typeof agentImprove == 'string' ? agentImprove : ''}
                                                            placeholder="Type here..."
                                                            maxLength="1500"
                                                            onInput={e => this.setState({agentImprove: e.target.value})}
                                                            onKeyDown={event =>
                                                                this.onAgentImproveKeyDown(event.target.value)
                                                            }
                                                            data-gramm="false"
                                                            data-gramm_editor="false"
                                                            data-enable-grammarly="false"
                                                        />
                                                    </div>
                                                </div>
                                                {agentImproveError && <p className="error">Max Characters 1500</p>}
                                                <input type="hidden" name="realtorId" value={realtorId} />
                                            </div>
                                        </div>
                                    )}
                                    {feedbackType === 'BUYER_FEEDBACK' && (
                                        <div>
                                            <div>
                                                {void(this.partCounter++)}
                                                <div className="visible-xs part-num">Part {this.partCounter} of {maxParts}</div>
                                                <div className="question">
                                                    <span className="part-q">How likely would you recommend UpNest to a friend?
                                                        <span className="required"> *Required</span>
                                                    </span>
                                                    <div className="hidden-xs part-num">Part {this.partCounter} of {maxParts}</div>
                                                </div>
                                                <RatingComponent
                                                    activeRange={nps}
                                                    minLabel={'Not all likely'}
                                                    maxLabel={'Extreme likely'}
                                                    onChange={newNPS => this.setState({nps: newNPS})}
                                                />
                                                {npsError && (<p className="error">This is a required field.</p>)}
                                            </div>
                                            <div>
                                                {void this.partCounter++}
                                                <div className="visible-xs part-num">
                                                    Part {this.partCounter} of {maxParts}
                                                </div>
                                                <div className="question">
                                                    <span className="part-q">
                                                        How can UpNest do better?
                                                        <span className="required"> *Required</span>
                                                    </span>
                                                    <span className="hidden-xs part-sub-q">
                                                        Did you like the website? Did we get you enough agent proposals?
                                                        Did we get you proposals fast enough?
                                                    </span>
                                                    <div className="hidden-xs part-num">
                                                        Part {this.partCounter} of {maxParts}
                                                    </div>
                                                </div>
                                                <div className="answers columned">
                                                    <div className="answer-item fill-width">
                                                        <textarea
                                                            className="answer-input improve-input"
                                                            value={
                                                                typeof upnestImprove == 'string' ? upnestImprove : ''
                                                            }
                                                            placeholder="Type here..."
                                                            maxLength="300"
                                                            onInput={e =>
                                                                this.setState({upnestImprove: e.target.value})
                                                            }
                                                            data-gramm="false"
                                                            data-gramm_editor="false"
                                                            data-enable-grammarly="false"
                                                        />
                                                    </div>
                                                </div>
                                                {upnestImproveError && (
                                                    <p className="error">This is a required field.</p>
                                                )}
                                            </div>
                                            <div>
                                                {void this.partCounter++}
                                                <div className="visible-xs part-num">
                                                    Part {this.partCounter} of {maxParts}
                                                </div>
                                                <div className="question">
                                                    <span className="part-q">
                                                        {realtorName ? (
                                                            <span>
                                                                How satisfied are you with the overall experience with{' '}
                                                                {realtorName}?
                                                            </span>
                                                        ) : (
                                                            <span>
                                                                How satisfied are you with the overall experience with
                                                                UpNest?
                                                            </span>
                                                        )}
                                                        <span className="required"> *Required</span>
                                                    </span>
                                                    <div className="hidden-xs part-num">
                                                        Part {this.partCounter} of {maxParts}
                                                    </div>
                                                </div>
                                                <RatingComponent5
                                                    activeRange={satisfaction}
                                                    minLabel={'Not at all satisfied'}
                                                    maxLabel={'Extremely satisfied'}
                                                    onChange={newSatisfaction =>
                                                        this.setState({satisfaction: newSatisfaction})
                                                    }
                                                />
                                                {satisfactionError && (
                                                    <p className="error">This is a required field.</p>
                                                )}
                                            </div>
                                            <div>
                                                {void this.partCounter++}
                                                <div className="visible-xs part-num">
                                                    Part {this.partCounter} of {maxParts}
                                                </div>
                                                <div className="question">
                                                    <span className="part-q">
                                                        {realtorName ? (
                                                            <span>Any feedback for your agent {realtorName}?</span>
                                                        ) : (
                                                            <span>Any feedback for UpNest?</span>
                                                        )}
                                                    </span>
                                                    <div className="hidden-xs part-num">
                                                        Part {this.partCounter} of {maxParts}
                                                    </div>
                                                </div>
                                                <div className="answers columned">
                                                    <div className="answer-item fill-width">
                                                        <textarea
                                                            className="answer-input improve-input"
                                                            value={typeof agentImprove == 'string' ? agentImprove : ''}
                                                            placeholder="Type here..."
                                                            maxLength="1500"
                                                            onInput={e => this.setState({agentImprove: e.target.value})}
                                                            onKeyDown={event =>
                                                                this.onAgentImproveKeyDown(event.target.value)
                                                            }
                                                            data-gramm="false"
                                                            data-gramm_editor="false"
                                                            data-enable-grammarly="false"
                                                        />
                                                    </div>
                                                </div>
                                                {agentImproveError && <p className="error">Max Characters 1500</p>}
                                            </div>
                                            <div style={'display: inline-block;'}>
                                                {void this.partCounter++}
                                                <div className="visible-xs part-num">
                                                    Part {this.partCounter} of {maxParts}
                                                </div>
                                                <div className="question">
                                                    <span className="part-q">
                                                        Please, endorse your agent {realtorName}
                                                    </span>
                                                    <div className="hidden-xs part-num">
                                                        Part {this.partCounter} of {maxParts}
                                                    </div>
                                                </div>
                                                <EndorsementComponent
                                                    endorsementList={availableEndorsements}
                                                    onClick={endorsementIds =>
                                                        this.setState({endorsementIds: endorsementIds})
                                                    }
                                                />
                                            </div>
                                        </div>
                                    )}
                                    <hr className="feedback-hr" />

                                    <div className="survey-footer">
                                        <button
                                            type="button"
                                            className="btn btn-default submit-button"
                                            onClick={this.submit.bind(this)}>
                                            Submit <i className="icon icon-arrow-direct-right" />
                                        </button>
                                    </div>
                                    {isLoading && (
                                        <div className="loadingSpinner" style="display: block">
                                            <img src={global.imageBaseUrl + 'spinner.gif'} />
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );

        if (this.state.maxParts != this.partCounter) {
            this.setState({maxParts: this.partCounter});
        }

        return <div className="client-nps-survey">{html}</div>;
    }
}

export default ClientNPSSurvey;
